let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("561p7")).then(() => parcelRequire('k8HS2'));